import { Injectable } from '@angular/core';

export interface SupplementalLoadsData {
  fml: number;  // Vertical load acting at lower edge of metal loss (lb / N)
  mml: number;  // Bending moment acting at lower edge of metal loss (ft-lb / kN-m)
}

@Injectable({ providedIn: 'root' })
export class SupplementalLoadsService {
  isAvailable: boolean = false;
  fml: number = -1;
  mml: number = -1;

  reset(): void {
    this.isAvailable = false;
    this.fml = -1;
    this.mml = -1;
  }

  getLoadsData(): SupplementalLoadsData {
    return { fml: this.fml, mml: this.mml };
  }

  setAvailable(available: boolean): void {
    this.isAvailable = available;
  }

  setFml(value: number): void {
    this.fml = value;
  }

  setMml(value: number): void {
    this.mml = value;
  }
}
